import * as TimeDisplayActions from './time-display.actions';

export default TimeDisplayActions;
